'use strict';

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

require('babel-polyfill');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _create = require('./redux/create');

var _create2 = _interopRequireDefault(_create);

var _ApiClient = require('./helpers/ApiClient');

var _ApiClient2 = _interopRequireDefault(_ApiClient);

var _reactRedux = require('react-redux');

var _convert = require('./helpers/convert');

var _convert2 = _interopRequireDefault(_convert);

var _reactRouter = require('react-router');

var _reactRouterScroll = require('react-router-scroll');

var _reactRouterScroll2 = _interopRequireDefault(_reactRouterScroll);

var _reactRouterRedux = require('react-router-redux');

var _reduxAsyncConnect = require('redux-async-connect');

var _routes = require('./routes');

var _routes2 = _interopRequireDefault(_routes);

var _config = require('./config');

var _config2 = _interopRequireDefault(_config);

var _reactGa = require('react-ga4');

var _reactGa2 = _interopRequireDefault(_reactGa);

var _reactGtmModule = require('react-gtm-module');

var _reactGtmModule2 = _interopRequireDefault(_reactGtmModule);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

if (_convert2.default.boolean(_config2.default.loggingOff)) {
  console.log = function () {};
}
// import useScroll from 'scroll-behavior/lib/useStandardScroll'
/**
 * THIS IS THE ENTRY POINT FOR THE CLIENT, JUST LIKE server.js IS THE ENTRY POINT FOR THE SERVER.
 */


var client = new _ApiClient2.default();
// const _browserHistory = useScroll(() => browserHistory)()
var _browserHistory = _reactRouter.browserHistory;
var dest = document.getElementById('content');
var store = (0, _create2.default)(_browserHistory, client, window.__data);
var history = (0, _reactRouterRedux.syncHistoryWithStore)(_browserHistory, store);

if (_config2.default.gaKey) {
  console.log('gaKey:', _config2.default.gaKey);
  _reactGa2.default.initialize([{
    trackingId: _config2.default.gaKey
  }]);
}

// https://medium.com/finnovate-io/integrating-google-tag-manager-with-a-react-app-5a8584ee2251
if (_config2.default.gtmId) {
  console.log('gtmId:', _config2.default.gtmId);
  _reactGtmModule2.default.initialize({
    gtmId: _config2.default.gtmId
  });
}

// scroll to the top or not?
var scrollBehavior = (0, _reactRouterScroll2.default)(function (prevRouterProps, _ref) {
  var location = _ref.location;

  // console.log('location:',location.pathname, prevRouterProps.location.pathname )
  return prevRouterProps && location.pathname !== prevRouterProps.location.pathname;
});

var lastUrl = null;
function logPageView() {
  var url = window.location.pathname + window.location.search + window.location.hash;
  // we're saving and checking last url bc
  // react-router is calling onUpdate twice for initial load
  // don't send if lastUrl is null;
  // because it's logging that page on ReactGA.initialize above.
  if (lastUrl !== url && lastUrl !== null) {
    console.log('GA url:', url);
    // set title to url to avoid 'off-by-one' title issue.
    // not perfect solution, because initial page load sends window title;
    // but at least it's accurate.
    _reactGa2.default.send({ hitType: "pageview", page: url, title: url });
    lastUrl = url;
  } else {
    lastUrl = url;
  }
}

function hashLinkScroll() {
  var hash = window.location.hash;

  if (hash !== '') {
    // Push onto callback queue so it runs after the DOM is updated,
    // this is required when navigating from a different page so that
    // the element is rendered on the page before trying to getElementById.
    setTimeout(function () {
      var id = hash.replace('#', '');
      var element = document.getElementById(id);
      if (element) element.scrollIntoView();
    }, 0);
  }
}
function hashLinkScrollLogView() {
  hashLinkScroll();
  if (_config2.default.gaKey) {
    logPageView();
  }
}

var component = _react2.default.createElement(
  _reactRouter.Router,
  {
    render: function render(props) {
      return _react2.default.createElement(_reduxAsyncConnect.ReduxAsyncConnect, (0, _extends3.default)({}, props, { helpers: { client: client }, filter: function filter(item) {
          return !item.deferred;
        },
        render: (0, _reactRouter.applyRouterMiddleware)(scrollBehavior)
      }));
    },
    history: history,
    onUpdate: hashLinkScrollLogView
  },
  (0, _routes2.default)(store)
);

_reactDom2.default.render(_react2.default.createElement(
  _reactRedux.Provider,
  { store: store, key: 'provider' },
  component
), dest);

if (process.env.NODE_ENV !== 'production') {
  window.React = _react2.default; // enable debugger

  if (!dest || !dest.firstChild || !dest.firstChild.attributes || !dest.firstChild.attributes['data-react-checksum']) {
    console.error('Server-side React render was discarded. Make sure that your initial render does not contain any client-side code.');
  }
}

if (__DEVTOOLS__ && !window.devToolsExtension) {
  var DevTools = require('./containers/DevTools/DevTools');
  _reactDom2.default.render(_react2.default.createElement(
    _reactRedux.Provider,
    { store: store, key: 'provider' },
    _react2.default.createElement(
      'div',
      null,
      component,
      _react2.default.createElement(DevTools, null)
    )
  ), dest);
}


//////////////////
// WEBPACK FOOTER
// ./src/client.js
// module id = 1313
// module chunks = 0